export default "__VITE_ASSET__MyWeKVq3__"